<template lang="pug">
.error-container
  .error-content
    img.error-icon(src='https://m.hellobike.com/resource/gallery/919/vcF_2dFzpX.png' alt='错误')
    .error-title {{ msg }}
    .error-desc 请检查网络连接后重试
    //- .retry-button(@click='handleRetry' v-flash="{scale:0.9,boom:true}") 刷新页面
</template>

<script>
export default {
  name: 'ErrorComponent',
  props: {
    msg: {
      type: String,
      default: '获取数据失败',
    },
  },
  methods: {
    handleRetry() {
      this.onRetry();
    },
    onRetry() {
      window.location.reload();
    },
  },
};
</script>

<style lang="less" scoped>
.error-container {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1000;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;

  .error-content {
    text-align: center;
    padding: 0.5rem;

    .error-icon {
      width: 1.91rem;
      height: 1.5rem;
      margin-bottom: 0.3rem;
    }

    .error-title {
      font-size: 0.18rem;
      color: #333;
      font-weight: 500;
      margin-bottom: 0.15rem;
    }

    .error-desc {
      font-size: 0.14rem;
      color: #999;
      margin-bottom: 0.5rem;
    }

    .retry-button {
      display: inline-block;
      width: 2.4rem;
      height: 0.5rem;
      line-height: 0.5rem;
      font-size: 0.15rem;
      color: #fff;
      background:
        linear-gradient(
          to right,
          #f13e7b,
          #f4573d,
        );
      border-radius: 0.25rem;
      cursor: pointer;
      transition: opacity 0.3s ease;

      &:active {
        opacity: 0.8;
      }
    }
  }
}
</style>
